import { TextField } from '@mui/material'
import { forwardRef, ForwardedRef } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { EFInputLabel } from '../EFInputLabel'
import { EFTextFieldProps } from './EFTextField.model'
import classNames from 'classnames/bind'
import styles from './EFTextField.module.scss'
import { CustomTextField } from './CustomTextField'

const cx = classNames.bind(styles)

export const EFNumericField = forwardRef(
  (props: EFTextFieldProps, _ref: ForwardedRef<unknown>) => {
    const { control, setValue } = useFormContext() ?? {}
    const theme = useAppSelector(currentTheme)
    const {validateFn, blurFn, ...baseProps} = props; //Some of these props shouldnt be passed down

    if (!control)
      return (
        <CustomTextField
          type='number'
          {...props}
        />
      )
    return (
      <Controller
        control={control}
        name={props.name}
        rules={{ validate: props.validateFn }}
        render={({ field, fieldState }) => (
          <div className='custom-field'>
            {props.label && (
              <EFInputLabel
                label={props.label}
                name={props.name}
                style={props.style}
              />
            )}
            <TextField
              {...baseProps}
              {...field}
              sx={{
                'input::-webkit-outer-spin-button,input::-webkit-inner-spin-button': {
                  WebkitAppearance: 'none',
                  margin: 0
                },
                'input[type=number]': {
                  MozAppearance: 'textfield'
                }
              }}
              autoComplete='off'
              type='number'
              name={field.name}
              value={field.value}
              placeholder={props.placeholder}
              id={field.name}
              InputLabelProps={{ style: { display: 'none' }, shrink: false }}
              className={cx('text-field', theme)}
              FormHelperTextProps={{
                sx: { marginX: 0, color: 'red !important' }
              }}
              onChange={(e: any) => {
                setValue(field.name, e.target.value, {
                  shouldValidate: true,
                  shouldDirty: true
                })
                props.onChange?.(e)
              }}
              onBlur={(e: any) => {
                //Use this to remove any leading zeroes from the value, it is ultimately resolved as a number but this tidies the display value
                const val = Number.parseFloat(e.target.value)
                if (!Number.isNaN(val) && val.toString() !== e.target.value) {
                  setValue(field.name, val.toString(), {
                    shouldValidate: true,
                    shouldDirty: true
                  })
                }
                props.blurFn?.(e);
              }}
              inputProps={{
                onKeyDown: event => {
                  // some browsers do not prevent non numerics in number fields
                  const allowedKeys = [
                    'Backspace',
                    'Tab',
                    'ArrowLeft',
                    'ArrowRight',
                    'ArrowUp',
                    'ArrowDown',
                    'Delete'
                  ]
                  const validKeyRegex = /^(?:\d|\.|-)$/ // Match digit, dot, or minus
                  if (
                    !validKeyRegex.test(event.key) &&
                    !allowedKeys.includes(event.key) &&
                    !event.ctrlKey
                  ) {
                    event.preventDefault()
                  }
                }
              }}
            />
          </div>
        )}
      />
    )
  }
)
